import { render } from "./members.vue?vue&type=template&id=037b3094&scoped=true"
import script from "./members.vue?vue&type=script&lang=js"
export * from "./members.vue?vue&type=script&lang=js"

import "./members.vue?vue&type=style&index=0&id=037b3094&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-037b3094"]])

export default __exports__